import { Injectable, Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class LoaderService {    

    constructor(@Inject(DOCUMENT) private document: Document, private renderer: Renderer2) { }

    ajaxLoaderStart(parentSelector: string, activateSelector: string): void {
        const element = this.document.querySelector(parentSelector);
        if (element) {
            this.renderer.addClass(element, activateSelector);
        }
    }

    ajaxLoaderEnd(parentSelector: string, activateSelector: string): void {
        const element = this.document.querySelector(parentSelector);
        if (element) {
            this.renderer.removeClass(element, activateSelector);
        }
    }
}